import { FC } from 'react';
import { RadabankOnboardingContent } from 'components/RadabankCard';
import { ArrowBackButton, CustomButton } from 'components/shared';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { useGoBackRadabank } from 'utils/hooks';
import { FirebaseAnalytics } from 'utils/services';

export const RadabankAuthInfoDocumentsSubmissionPage: FC = () => {
	const handleClickBack = useGoBackRadabank();

	const handleGoBack = () => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.DOCUMENTS_SUBMISSION,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_BACK
		);
		handleClickBack();
	};

	return (
		<div className="host-card-page-color-primary">
			<ArrowBackButton onClick={handleGoBack} />
			<RadabankOnboardingContent
				title="Надання документів"
				description={[
					'Надані документи вимагають додаткової перевірки.',
					'Ви отримаєте повідомлення, коли все буде готово',
				]}
			/>
			<CustomButton label="Повернутись" color="secondary" onClick={handleGoBack} />
		</div>
	);
};
